import { useEffect } from "react";

const { useState } = require("react")


const useWebSocket = (url) => {
    const [liveUsers, setLiveUsers] = useState();

    useEffect(() => {
        let socket = new WebSocket(url);

        socket.onopen = () => {
            // console.log("WebSocket connected!");
        };

        socket.onmessage = (event) => {
            setLiveUsers(parseInt(event.data, 10)); // Update live user count
        };

        socket.onclose = () => {
            // console.log("WebSocket disconnected. Reconnecting in 5 sec...");
            setTimeout(() => {
                socket = new WebSocket(url); // ✅ Reconnect WebSocket properly
            }, 5000);
        };

        socket.onerror = (error) => {
            console.error("WebSocket error:", error);
        };

        return () => {
            socket.close();
        };
    }, [url]);

    return liveUsers;
}

export default useWebSocket;